import React, { Fragment } from "react";
import PropTypes from 'prop-types';
import { Col, Card, Row } from "react-bootstrap";
import { Button } from '@mui/material';
import { ArrowDownwardSharp as ArrowDownwardSharpIcon } from '@mui/icons-material';
import { ArrowUpwardSharp as ArrowUpwardSharpIcon } from '@mui/icons-material';
import CurrenyFormat from '../../../Helpers/Formatters/CurrencyFormat';

import '../../Quoter.scss';

export default function QuoteCardTermAlternative(props) {
  const priceDifference = Math.abs(100 * (props.monthlyRate - props.compareTo) / props.compareTo)

  const getBadge = () => {
    // if this product has more than 1 badge, display the badge that corresponds to the sorting if available
    var bestCount = [props.isBestPrice, props.isFastest, props.isMostOptions].filter((f) => f === true).length;

    if (bestCount > 1) {
      console.log('this has more than 1 badge');
      console.log('sortBy', props.sortBy);

      if (props.isBestPrice === 'price') {
        return (
          <Fragment>
            Best <br /> Price
          </Fragment>
        );
      }

      if (props.isFastest === 'speed') {
        return (
          <Fragment>
            <br />
            Fastest
          </Fragment>
        );
      }

      if (props.isMostOptions === 'options') {
        return (
          <Fragment>
            Most <br />
            Options
          </Fragment>
        );
      }
    }

    // now either it only has 1 badge, or it doesn't have the badge being sorted by, so pick one

    if (props.isBestPrice) {
      return (
        <Fragment>
          Best <br />
          Price
        </Fragment>
      );
    }

    if (props.isFastest) {
      return (
        <Fragment>
          <br />
          Fastest
        </Fragment>
      );
    }

    return (
      <Fragment>
        Most <br />
        Options
      </Fragment>
    );
  };
  const quoteStyle = props.compareTo <= props.monthlyRate ? 'quote-underwriting-time-more' : 'quote-underwriting-time';

  return (
    <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 d-flex colPadding">
      <label hidden={true} id={`option-${props.id}`}>{props.productName} Traditional Term Isurance Option</label>
      {(props.isBestPrice || props.isFastest || props.isMostOptions) && <div className={`ribbon primary-bg-color`}>{getBadge()}</div>}
      <Card className="card-border flex-fill mx-auto" aria-labelledby={`option-${props.id}`}>
        <Card.Body className="card-body">
          <div className="d-flex flex-column align-items-left">
            <img className="carrier-logo" src={props.logoUrl} alt={`${props.carrierName} Logo`} width="100" />
            <div className={`card-term-rating primary-color`}>{props.rating} Rating</div>
            <div className={quoteStyle}>
              <span>
                {props.compareTo <= props.monthlyRate ? <ArrowUpwardSharpIcon color="action" /> : <ArrowDownwardSharpIcon color="action" />}{priceDifference.toFixed()}% {props.compareTo <= props.monthlyRate ? 'more' : 'less'} expensive
              </span>
            </div>
            <p className='quote-product-name'>{props.productName}</p>
            <div className='pb-2'>
              <Row>
                <Col>
                  <CurrenyFormat className="quote-amount-dollars card-rate" removeSymbol number={props.monthlyRate && parseFloat(props.monthlyRate.toFixed(2))} /> <span className='quote-dollar-symbol'>/mo</span>
                </Col>
                <Col>
                  <p className="stat-title">Typically takes</p>
                  <p className={`underwriting-text primary-color`}>{props.isAccel ? '1-2 Days' : '1-2 Months'}</p>
                </Col>
              </Row>
              <Row>
                <Col></Col>
                <Col>
                  <p className="stat-title">Medical Exam</p>
                  <p className={`underwriting-medical-text mb-0 primary-color`}>{props.requiresMedicalExam}</p>
                </Col>
              </Row>
            </div>
            <Button color="primary" variant="contained" onClick={props.onNextApply}>Select</Button>
            <div className="d-flex mt-2 justify-content-center">
              <Button className="link-button" onClick={() => { props.setProductInfoDialogOpen(true) }}>PRODUCT DETAILS</Button>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}


QuoteCardTermAlternative.propTypes = {
  compareTo: PropTypes.number.isRequired,
  monthlyRate: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  productName: PropTypes.string.isRequired,
  logoUrl: PropTypes.string.isRequired,
  carrierName: PropTypes.string.isRequired,
  isAccel: PropTypes.bool,
  onNextApply: PropTypes.func.isRequired,
}

